import { computed, inject, Injectable, resource } from '@angular/core';
import { DeveloperRepository } from '../repositories/developer.repository';
import { SOFTLINE_CONFIG_DEVELOPER_PASSWORD } from '@softline/application';

export const DEVELOPER_LOCAL_STORAGE_KEY = 'SoftApps Developer';

@Injectable({ providedIn: 'root' })
export class DeveloperService {
  private readonly repository = inject(DeveloperRepository);
  private readonly password = inject(SOFTLINE_CONFIG_DEVELOPER_PASSWORD);

  private readonly _resource = resource({
    loader: () => this.repository.load(undefined),
  });

  isDeveloper = computed(() => this._resource.value()?.isDeveloper ?? false);

  async su(password: string): Promise<boolean> {
    if(password !== this.password) {
      console.warn('[DeveloperStore] Password is wrong');
      return false;
    }
    const result = await this.repository.create({isDeveloper: true}, undefined);
    this._resource.set(result);
    return true;
  }

  async exit(): Promise<void> {
    const result = await this.repository.delete(undefined);
    this._resource.set(result);
  }
}
